import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
var Stars = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Stars, _Component);

  var _super = _createSuper(Stars);

  function Stars() {
    var _this;

    _classCallCheck(this, Stars);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderStars", function () {
      var scale = _this.props.scale;
      var value = Math.round(_this.props.value * 2) / 2; // round to nearest half

      var starStyles = {};
      starStyles.color = _this.props.color ? _this.props.color : _this.props.theme.colors.secondaryColor;
      starStyles.fontSize = _this.props.fontSize;
      starStyles.padding = '0 1px';
      var stars = [];

      for (var x = 1; x <= scale; x++) {
        if (Math.floor(value) >= x) {
          // full stars
          stars.push( /*#__PURE__*/React.createElement("i", {
            style: starStyles,
            className: "icon ion-ios-star",
            key: x
          }));
        } else if (value > x - 1) {
          // half stars
          stars.push( /*#__PURE__*/React.createElement("i", {
            style: starStyles,
            className: "icon ion-ios-star-half",
            key: x
          }));
        } else {
          // empty stars
          stars.push( /*#__PURE__*/React.createElement("i", {
            style: starStyles,
            className: "icon ion-ios-star-outline",
            key: x
          }));
        }
      }

      return stars;
    });

    return _this;
  }

  _createClass(Stars, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderStars());
    }
  }]);

  return Stars;
}(Component), _defineProperty(_class2, "propTypes", {
  value: PropTypes.number.isRequired,
  scale: PropTypes.number,
  color: PropTypes.string,
  fontSize: PropTypes.number
}), _defineProperty(_class2, "defaultProps", {
  fontSize: 13,
  scale: 5
}), _temp)) || _class);
export default Stars;